import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/accordion.module.scss'
import { Checkbox } from 'components/Form'

type Props = {
  toggleCheckbox: () => void
  id: string
  isChecked: boolean
  label: string
  children: ReactNode
}

const Accordion: FC<Props> = (props) => {
  const { children, toggleCheckbox, id, isChecked, label } = props

  return (
    <div className={isChecked ? styles.open : ''}>
      <p className={styles.accordion}>
        <Checkbox id={id} isChecked={isChecked} label={label} handleCheckbox={toggleCheckbox} size={'large'} />
      </p>
      {children}
    </div>
  )
}

export default Accordion
